import { defineMessages } from 'react-intl';

export default defineMessages({
  year: {
    id: 'suivi_sinistre.year',
  },
  currentYear: {
    id: 'suivi_sinistre.current_year',
  },
});
